import { useEffect } from "react";
import type { Product } from "./productTheme";

export function useProductIdentity(product: Product, surface: string) {
  useEffect(() => {
    const oldTitle = document.title;
    const icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    const oldHref = icon?.getAttribute("href");
    const oldType = icon?.getAttribute("type");
    document.title = `${surface} · ${product === "bondoq" ? "Bondoq" : "Rentinit"}`;
    if (product === "bondoq" && icon) {
      icon.href = "/brand/bondoq-favicon.svg";
      icon.type = "image/svg+xml";
    }
    return () => {
      document.title = oldTitle;
      if (icon && oldHref !== null && oldHref !== undefined)
        icon.setAttribute("href", oldHref);
      if (icon) {
        if (oldType) icon.setAttribute("type", oldType);
        else icon.removeAttribute("type");
      }
    };
  }, [product, surface]);
}
